import { render, staticRenderFns } from "./checkbox-modal-default.mpx?vue&type=template&id=265dfb1c&isComponent&outputPath=components%2Fcheckbox-modal-default4eb0b56e%2Findex"
import script from "./checkbox-modal-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcheckbox-modal-default4eb0b56e%2Findex"
export * from "./checkbox-modal-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcheckbox-modal-default4eb0b56e%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports